<template>
	<div class="taotiziyuan-container">
		<div class="header-wrapper">
			<jikaoHeader />
		</div>
		<div class="banner">
			<div class="banner-content">
				<img src="@/assets/svg/erji.svg" alt="logo" class="banner-icon" />
				<div class="banner-text">
					<h1>安徽省普通高考英语听力计算机化考试</h1>
					<h2>在线模拟练习系统</h2>
				</div>
			</div>
		</div>
		<div class="content">
			<div class="card-title">套题资源</div>
			
			<div class="list-container">
				<div class="toolbar">
					<div class="left-section">
						<div class="tab-group">
							<div 
								class="tab-btn" 
								:class="{ active: activeTab === 'self' }"
								@click="handleTabChange('self')"
							>自组机考</div>
							<div 
								class="tab-btn" 
								:class="{ active: activeTab === 'class' }"
								@click="handleTabChange('class')"
							>班级机考</div>
						</div>
					</div>
					
					<div class="notice">
						{{ activeTab === 'self' ? '请选择两套不同的试题做为考试资源，点击A卷/B卷选择' : '请选择一套班级机考试题做为考试资源 (已含AB卷)' }}
					</div>
					
					<div class="right-section">
						<el-button type="success" class="start-btn" @click="startExam">开始考试</el-button>
					</div>
				</div>
				
				<div class="paper-list">
					<div 
						v-for="(item, index) in listData" 
						:key="item.id || index" 
						class="paper-item"
					>
						<div class="paper-name">{{ item.title }}</div>
						<div class="paper-actions">
							<template v-if="activeTab === 'self'">
								<div 
									class="select-btn" 
									:class="{ active: item.selected === 'A' }"
									@click="selectPaper(item, 'A')"
								>A卷</div>
								<div 
									class="select-btn" 
									:class="{ active: item.selected === 'B' }"
									@click="selectPaper(item, 'B')"
								>B卷</div>
							</template>
							<template v-else>
								<div 
									class="select-btn class-btn" 
									:class="{ active: item.selected }"
									@click="selectPaper(item, 'class')"
								>{{ item.selected ? '已选' : '选择' }}</div>
							</template>
						</div>
					</div>
				</div>
				
				<div class="pagination-container">
					<el-pagination
						@current-change="handlePageChange"
						:current-page.sync="currentPage"
						:page-size="pageSize"
						layout="total, prev, pager, next, jumper"
						:total="total"
						background
					>
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import jikaoHeader from '@/components/hearder/jikaoHeader.vue';

export default {
	name: 'taotiziyuan',
	components: {
		jikaoHeader
	},
	data() {
		return {
			activeTab: 'self',
			currentPage: 1,
			pageSize: 10,
			total: 0,
			listData: [],
			listLoading: false,
			selectedSelfAId: null,
			selectedSelfBId: null,
			selectedClassId: null,
			selectedSelfASource: null,
			selectedSelfBSource: null,
			selectedClassSource: null
		};
	},
	created() {
		this.fetchList();
	},
	methods: {
		handleTabChange(tab) {
			if (this.activeTab === tab) return;
			this.activeTab = tab;
			this.currentPage = 1;
			this.fetchList();
		},
		getClassification() {
			return this.activeTab === 'self' ? 1 : 2;
		},
		normalizeListResponse(res) {
			if (Array.isArray(res?.rows)) {
				return { rows: res.rows, total: Number(res.total || 0) };
			}
			if (Array.isArray(res?.data?.records)) {
				return { rows: res.data.records, total: Number(res.data.total || 0) };
			}
			if (Array.isArray(res?.data?.list)) {
				return { rows: res.data.list, total: Number(res.data.total || 0) };
			}
			if (Array.isArray(res?.data)) {
				return { rows: res.data, total: Number(res.total || res.data.length || 0) };
			}
			return { rows: [], total: 0 };
		},
		fetchList() {
			this.listLoading = true;
			const params = {
				classification: this.getClassification(),
				pageNum: this.currentPage,
				pageSize: this.pageSize
			};
			this.$http
				.get('api/app/yydComputerizedExamPaper/sourceList', { params })
				.then((res) => {
					this.listLoading = false;
					if (res?.code !== 200 && res?.code !== 0) return;
					const { rows, total } = this.normalizeListResponse(res);
					this.total = total;
					this.listData = (rows || []).map((r) => {
						let selected = null;
						if (this.activeTab === 'self') {
							if (this.selectedSelfAId === r.id) selected = 'A';
							else if (this.selectedSelfBId === r.id) selected = 'B';
						} else {
							selected = this.selectedClassId === r.id;
						}
						return {
							id: r.id,
							title: r.title,
							source: r.source,
							selected
						};
					});
				})
				.catch(() => {
					this.listLoading = false;
				});
		},
		selectPaper(item, type) {
			if (this.activeTab === 'self') {
				if (item.selected === type) {
					item.selected = null;
					if (type === 'A') this.selectedSelfAId = null;
					if (type === 'B') this.selectedSelfBId = null;
					if (type === 'A') this.selectedSelfASource = null;
					if (type === 'B') this.selectedSelfBSource = null;
				} else {
					if (type === 'A' && this.selectedSelfBId === item.id) {
						this.selectedSelfBId = null;
						this.selectedSelfBSource = null;
					}
					if (type === 'B' && this.selectedSelfAId === item.id) {
						this.selectedSelfAId = null;
						this.selectedSelfASource = null;
					}

					this.listData.forEach(i => {
						if (i !== item && i.selected === type) i.selected = null;
					});
					item.selected = type;

					if (type === 'A') this.selectedSelfAId = item.id;
					if (type === 'B') this.selectedSelfBId = item.id;
					if (type === 'A') this.selectedSelfASource = item.source;
					if (type === 'B') this.selectedSelfBSource = item.source;
				}
			} else {
				const isSelected = !!item.selected;
				this.listData.forEach(i => (i.selected = false));
				if (isSelected) {
					item.selected = false;
					this.selectedClassId = null;
					this.selectedClassSource = null;
				} else {
					item.selected = true;
					this.selectedClassId = item.id;
					this.selectedClassSource = item.source;
				}
			}
		},
		startExam() {
			if (this.activeTab === 'self') {
				if (
					!this.selectedSelfAId ||
					!this.selectedSelfBId ||
					this.selectedSelfAId === this.selectedSelfBId ||
					!this.selectedSelfASource ||
					!this.selectedSelfBSource
				) {
					this.$message.warning('请选择一套A卷和一套B卷');
					return;
				}
				// this.$message.success('开始自组机考');
				this.$router.push({
					path: '/shiting',
					query: {
						classification: 1,
						paperAId: this.selectedSelfAId,
						sourceA: this.selectedSelfASource,
						paperBId: this.selectedSelfBId,
						sourceB: this.selectedSelfBSource
					}
				});
			} else {
				if (!this.selectedClassId || !this.selectedClassSource) {
					this.$message.warning('请选择一套班级机考试题');
					return;
				}
				// this.$message.success('开始班级机考');
				this.$router.push({
					path: '/shiting',
					query: {
						classification: 2,
						paperId: this.selectedClassId
					}
				});
			}
		},
		handlePageChange(val) {
			this.currentPage = val;
			this.fetchList();
		}
	}
};
</script>

<style lang="scss" scoped>
.taotiziyuan-container {
	height: 100vh;
	overflow: hidden;
	background: #fff;
	display: flex;
	flex-direction: column;

	.header-wrapper {
		flex-shrink: 0;
	}

	.banner {
		height: 260px;
		background: #0080ff;
		display: flex;
		justify-content: center;
		align-items: flex-start;
		padding-top: 50px;
		box-sizing: border-box;
		flex-shrink: 0;
		
		.banner-content {
			position: relative;
			display: flex;
			align-items: center;
			color: #fff;
			
			.banner-icon {
				position: absolute;
				right: 100%;
				width: 70px;
				height: 70px;
				margin-right: 20px;
			}
			
			.banner-text {
				h1 {
					font-size: 34px;
					margin: 0;
					font-weight: 500;
					letter-spacing: 1px;
				}
				h2 {
					font-size: 22px;
					margin: 8px 0 0;
					font-weight: normal;
					text-align: center;
					opacity: 0.9;
				}
			}
		}
	}

	.content {
		width: 1200px;
		margin: -60px auto 20px;
		height: calc(100vh - 280px); /* Adjusted to prevent overflow with header */
		background: #fff;
		border-radius: 20px;
		padding: 20px 30px;
		box-sizing: border-box;
		box-shadow: 0 10px 30px rgba(0,0,0,0.1);
		z-index: 10;
		display: flex;
		flex-direction: column;
		
		.card-title {
			text-align: center;
			color: #409eff;
			font-size: 26px;
			font-weight: bold;
			margin-bottom: 20px;
			letter-spacing: 2px;
			flex-shrink: 0;
		}

		.list-container {
			background: #f5f5f5;
			border-radius: 12px;
			padding: 20px;
			flex: 1;
			display: flex;
			flex-direction: column;
			overflow: hidden;
			
			.toolbar {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 15px;
				flex-shrink: 0;
				position: relative;
				
				.tab-group {
					display: flex;
					gap: 10px;
					
					.tab-btn {
						padding: 6px 20px;
						cursor: pointer;
						background: #fff;
						color: #333;
						border: 1px solid #dcdfe6;
						border-radius: 4px;
						font-size: 14px;
						transition: all 0.3s;
						
						&.active {
							background: #0080ff;
							color: #fff;
							border-color: #0080ff;
						}
						
						&:hover:not(.active) {
							color: #409eff;
							border-color: #c6e2ff;
							background-color: #ecf5ff;
						}
					}
				}
				
				.notice {
					color: #f56c6c;
					font-size: 14px;
					font-weight: bold;
					position: absolute;
					left: 50%;
					transform: translateX(-50%);
				}
				
				.start-btn {
					background-color: #458d59;
					border-color: #458d59;
					padding: 8px 25px;
					font-size: 15px;
					border-radius: 4px;
					
					&:hover {
						background-color: #52a368;
						border-color: #52a368;
						color: #fff;
					}
				}
			}
			
			.paper-list {
				margin-bottom: 15px;
				flex: 1;
				overflow-y: auto;
				padding-right: 5px; // For scrollbar
				
				// Custom scrollbar styling
				&::-webkit-scrollbar {
					width: 6px;
				}
				&::-webkit-scrollbar-thumb {
					background: #ccc;
					border-radius: 3px;
				}
				&::-webkit-scrollbar-track {
					background: transparent;
				}
				
				.paper-item {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 12px 20px;
					background: #e6e6e6;
					border-radius: 6px;
					margin-bottom: 8px;
					
					.paper-name {
						font-size: 15px;
						color: #333;
						font-weight: 500;
					}
					
					.paper-actions {
						display: flex;
						gap: 10px;
						
						.select-btn {
							padding: 4px 12px;
							border: 1px solid #409eff;
							border-radius: 4px;
							cursor: pointer;
							color: #409eff;
							font-size: 13px;
							background: #fff;
							transition: all 0.2s;
							min-width: 36px;
							text-align: center;
							
							&.active {
								background: #0080ff;
								color: #fff;
								border-color: #0080ff;
							}

							&.class-btn {
								min-width: 50px;
							}
						}
					}
				}
			}
			
			.pagination-container {
				text-align: center;
				margin-top: 0;
				flex-shrink: 0;
				
				::v-deep .el-pagination {
					padding: 0;
					.el-pager li {
						background: #fff;
						min-width: 28px;
						height: 28px;
						line-height: 28px;
						&.active {
							background-color: #0080ff;
							color: #fff;
						}
					}
					.btn-prev, .btn-next {
						background: #fff;
						min-width: 28px;
						height: 28px;
						line-height: 28px;
					}
				}
			}
		}
	}
}
</style>
